import { alphabeticalSorter } from "@suse-o11y/alphabetical-sorter";
import type { Namable } from "@suse-o11y/namable";
import type { Sorter } from "@suse-o11y/sorter";

export const namableAlphabeticalSorter: Sorter<Namable> = (left, right) => alphabeticalSorter(left.name, right.name);
